import { Route, Routes } from "react-router-dom"

import { NetworkReferentialLayer } from "@l2r-front/l2r-networks"
import { API_MODULE_CAMPAIGN, MODULE_CAMPAIGNS } from "@l2r-front/l2r-shared-campaign"

import { CampaignLayer } from "../../containers/CampaignLayer"
import { MultiCampaignsLayer } from "../../containers/MultiCampaignsLayer"

export const CampaignMapRouter = () => {

    return (
        <Routes>
            <Route
                element={
                    <>
                        <NetworkReferentialLayer module={API_MODULE_CAMPAIGN} />
                        <MultiCampaignsLayer />
                    </>
                }
                path={`/${MODULE_CAMPAIGNS}`}
            />
            <Route
                element={
                    <>
                        <NetworkReferentialLayer module={API_MODULE_CAMPAIGN} />
                        <CampaignLayer />
                    </>
                }
                path={`/${MODULE_CAMPAIGNS}/:campaignId`}
            />
        </Routes>
    )
}